import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { withTheme } from 'styled-components';

class Loading extends React.Component {
  static propTypes = {
    message: PropTypes.string,
    width: PropTypes.string,
  };

  static defaultProps = {
    message: '',
    width: "42px",
  };

  render() {
    return (
      <div style={{ textAlign: 'center' }}>
        <img src={get(this.props.theme, "loadingGif")} style={{ width: this.props.width }} alt="" />
        <p style={{ color: '#ccc' }}>{this.props.message}</p>
      </div>
    );
  }
}

export default withTheme(Loading);
